import { isStringEmpty } from "../utils/functions"
import httpModule from "../utils/http"

const BrokerService = async (inputValue, comapny = ""): Promise<any[]> => {
  const request = {
    ordenamiento: { columna: 1, direccion: "asc" },
    paginado: {
      pagina: 1,
      registrosPorPagina: 310
    },
    filtro: {
      tipo: "null",
      modoTransporte: "null",
      idTipoCliente: "null",
      paises: null,
      clientes: null,
      lugar: null,
      anio: null,
      mesDesde: null,
      mesHasta: null,
      sinComercialAsignado: null,
      comercialAsignado: null,
      despachante: inputValue
    }
  }
  return await httpModule.post(`/api/backoffice/v1/aduana/despachantes`, request).then(res => {
    return res.data.despachantes
      .filter(item => isStringEmpty(comapny) || item.razonSocial.toLowerCase() !== comapny.toLowerCase())
      .map(item => {
        return { value: item, label: item }
      })
  })
}

export default BrokerService
